import React from 'react';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';

const IconWrap = ({ delta }) => {
  if (!delta) return null;
  const dir = delta[0];
  const Ico = dir === 'up' ? TrendingUp : dir === 'down' ? TrendingDown : Minus;
  return <Ico size={11} strokeWidth={2.5} />;
};

export default function KpiCard({ icon: Icon, iconCls = 'ic-gold', value, label, delta, last, testId, title }) {
  return (
    <div className="kpi-card" data-testid={testId}>
      {Icon && (
        <div className={`kpi-icon ${iconCls}`}>
          <Icon size={18} strokeWidth={2} />
        </div>
      )}
      <div className="kpi-number" title={title}>{value}</div>
      <div className="kpi-label">{label}</div>
      {delta && (
        <div className={`kpi-delta ${delta[0]}`}>
          <IconWrap delta={delta} /> {delta[1]}
        </div>
      )}
      {last && <div className="kpi-last">{last}</div>}
    </div>
  );
}
